import {
  REGULATORY_JOBS_API_ENDPOINTS,
  REGULATORY_NOTIFICATIONS_API_ENDPOINTS,
  SOURCES_API_ENDPOINTS,
} from '@/constants';
import { api } from '@/services';
import { ApiResponse, PagedResponse } from '@/types';

import {
  IJob,
  ISource,
  IJobSearchingPayload,
  INotification,
  INotificationSearchingPayload,
} from '@/features/regulatory-intake/intake-list/interfaces';

export const IntakeListService = {
  notificationSearch: async (
    payload: INotificationSearchingPayload,
  ): Promise<PagedResponse<INotification>> => {
    const response = await api.post<ApiResponse<PagedResponse<INotification>>>(
      REGULATORY_NOTIFICATIONS_API_ENDPOINTS.NOTIFICATIONS_SEARCH,
      payload,
    );
    return response.data.data;
  },

  jobSearch: async (payload: IJobSearchingPayload): Promise<PagedResponse<IJob>> => {
    const response = await api.post<ApiResponse<PagedResponse<IJob>>>(
      REGULATORY_JOBS_API_ENDPOINTS.JOBS_SEARCH,
      payload,
    );
    return response.data.data;
  },

  jobManualTrigger: async (): Promise<ApiResponse<string>> => {
    const response = await api.post<ApiResponse<string>>(
      REGULATORY_JOBS_API_ENDPOINTS.JOBS_MANUAL_TRIGGER,
    );
    return response.data;
  },

  jobRetry: async (jobId: string) => {
    const response = await api.post(
      REGULATORY_JOBS_API_ENDPOINTS.JOB_RETRY.replace(':jobId', jobId),
    );
    return response.data;
  },

  sourceDetails: async (): Promise<ISource> => {
    const response = await api.get<ApiResponse<ISource>>(SOURCES_API_ENDPOINTS.SOURCE_DETAILS);
    return response.data.data;
  },
};
